import axios from 'axios'

let subscriptionRequestInFlight = null;

const getSubscription = (options = {}) => {
  const { forceRefresh = false } = options;

  if (forceRefresh) {
    subscriptionRequestInFlight = null;
  }

  if (subscriptionRequestInFlight) {
    return subscriptionRequestInFlight;
  }

  subscriptionRequestInFlight = axios
    .get('/account/subscription')
    .finally(() => {
      subscriptionRequestInFlight = null;
    });

  return subscriptionRequestInFlight;
};

export default {
  getDetails: () => axios.get('/account/details'),
  getBilling: () => axios.get('/account/billing'),
  saveBilling: (data) => axios.post('/account/billing', data),
  parseBillingCif: (data) => axios.post('/account/billing/parse-cif', data),
  getSubscription,
  storeSubscriptionCard: (data) => axios.post('/account/subscription/card', data),
  deleteSubscriptionCard: () => axios.delete('/account/subscription/card'),
  quoteSubscriptionPurchase: (data) => axios.post('/account/subscription/quote', data),
  purchaseSubscription: (data) => axios.post('/account/subscription/purchase', data),
  issueSubscriptionInvoice: (chargeId) => axios.post('/account/subscription/invoice-issue', {
    charge_id: chargeId,
  }),
  downloadSubscriptionInvoiceXml: (chargeId) => axios.post('/account/subscription/invoice-xml', {
    charge_id: chargeId,
  }, {
    responseType: 'blob',
  }),
  downloadSubscriptionInvoicePdf: (chargeId) => axios.post('/account/subscription/invoice-pdf', {
    charge_id: chargeId,
  }, {
    responseType: 'blob',
  }),
  update: (data) => axios.post('/account/update', data),
  activityTouch: (payload = {}) => axios.post('/account/activity-touch', payload, { skipLoading: true }),
  getMcpConfig: () => axios.get('/account/mcp-config'),
  regenerateMcpToken: () => axios.post('/account/mcp-config/regenerate'),
  requestWhatsappVerification: (data) => axios.post('/account/whatsapp/request-verification', data),
  confirmWhatsappVerification: (data) => axios.post('/account/whatsapp/confirm-verification', data),
  changePassword: (data) => axios.post('/account/change-password', data),
  getAdminAccountsSummary: () => axios.get('/admin/accounts-summary'),
  getAdminDownloadRequestsMetrics: (range = 'today') => axios.post('/admin/download-requests/metrics', {
    range,
  }),
  impersonateAdminAccount: (accountId) => axios.post('/admin/accounts/impersonate', {
    account_id: accountId,
  }),
  updateAdminAccountPackage: (accountId, packageId) => axios.post('/admin/accounts/update-package', {
    account_id: accountId,
    package_id: packageId,
  }),
  updateAdminAccountValidity: (accountId, endsAt) => axios.post('/admin/accounts/update-validity', {
    account_id: accountId,
    ends_at: endsAt,
  }),
  getAdminAccountDeletionSummary: (accountId) => axios.post('/admin/accounts/deletion-summary', {
    account_id: accountId,
  }),
  deleteAdminAccount: (accountId, confirmationWord) => axios.post('/admin/accounts/delete', {
    account_id: accountId,
    confirmation_word: confirmationWord,
  }),
  getAdminAccountWhatsappConversation: (accountId, options = {}) => axios.post('/admin/accounts/whatsapp-conversation', {
    account_id: accountId,
    limit: options.limit || 50,
    before_id: options.beforeId || null,
  }),
  sendAdminAccountWhatsappReply: (accountId, message) => axios.post('/admin/accounts/whatsapp-reply', {
    account_id: accountId,
    message_type: 'direct',
    message,
  }),
  sendAdminAccountWhatsappTemplate: (accountId, templateKey) => axios.post('/admin/accounts/whatsapp-reply', {
    account_id: accountId,
    message_type: 'template',
    template_key: templateKey,
  }),
  generateAdminAccountUserPassword: (accountId, userId = null) => axios.post('/admin/accounts/generate-user-password', {
    account_id: accountId,
    user_id: userId,
  }),
}
